import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MapsService } from 'src/app/services/maps.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { map, retry, takeUntil } from 'rxjs/operators'
import { MatDialog } from '@angular/material/dialog';
import { UpdateNoteModalComponent } from '../update-note-modal/update-note-modal.component';
import { CreateNoteModalComponent } from '../create-note-modal/create-note-modal.component';
import * as moment from 'moment';

@Component({
  selector: 'fury-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class LeadDetailsComponent implements OnInit, AfterViewInit {

  firstname: string = '';
  lastname: string = '';
  email: string = '';
  city: string = '';
  state: string = '';
  position: number = 0;

  dataSource: Array<any> = [];
  relatedLeadDataSource:Array<any> = [];

  reletedLeadDisplayColumn: string[] = ['firstName', 'lastName', 'emailAddress', 'attempts', 'address', 'city', 'zip', 'action'];

  displayedColumns: string[] = ['agreementNumber', 'firstName', 'lastName', 'total_amount', 'agreementStartDate', 'action'];
  id!: any;
  leadDetails!: any;
  paramName!: any;
  propertyTypeList!: any;
  propertySizeList!: any;
  noteLists!: any;
  selectCoverItems: any = [];
  planList: any = [];
  planListCoverItems: any = [];
  coverItemList: any = [];
  selectedCoverItemList:any =[];
  blacklistedIpAdddressList:any = [];
  customerInformationForm!: FormGroup;
  sourceForm!: FormGroup;
  securityForm!: FormGroup;
  propertyInfoForm!: FormGroup;
  notesForm!: FormGroup;
  coverageInfoForm!: FormGroup;
  paymentInfoForm!: FormGroup;
  loader: boolean = true;
  subs: Subscription[] = [];
  @ViewChild('prpoertyLocation', { static: false }) public prpoertyLocation!: ElementRef;
  @ViewChild('billingLocation', { static: false }) public billingLocation!: ElementRef;
  @ViewChild('coverageAddress', { static: false }) public coverageAddress!: ElementRef;
  @ViewChild('mailingAddress', { static: false }) public mailingAddress!: ElementRef;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  constructor(
    public apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private mapsService: MapsService,
    private dialog: MatDialog
  ) {
    this.activatedRoute.queryParams.subscribe((res: any) => { 
      this.paramName = res.type;
    });
    this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      if (params['id']) {
        this.formInit();
        this.getBlackListedIpaddress();
        this.getPropertySizeList();
        this.getPropertyType();
        this.getPlanList().then(() => {
          this.getLeadDetails();
        });
        // this.getLeadDetails();
        this.getCoverItemList();
        this.getRelatedPolicieList();
        this.getRelatedLeadList();
      }
    });
  }

  ngOnInit(): void {
    this.coverageInfoForm.get('planId')?.valueChanges.subscribe((res: any) => {
      let tempData = this.planList.find((elm: any) => {
        return elm?.planOptionalItemCategoryId === res;
      });
      if(this.planListCoverItems) {
      this.planListCoverItems = tempData?.coveredItems.map((item: any) => {
        return { ...item, isChecked: false };
      });
    }
    });

    this.propertyInfoForm.get('billingAddress.sameAsPropertyAddress')?.valueChanges.subscribe((res: any) => {
      if (res) {
        this.propertyInfoForm.patchValue({
          billingAddress: this.propertyInfoForm?.value?.propertyAddress
        })
      } else {
        this.propertyInfoForm.patchValue({
          billingAddress: {
            unitNumber: null,
            address: null,
            state: null,
            city: null,
            zip: null,
          }
        })
      }
    });
    
    this.propertyInfoForm.get('mailingAddress.sameAsPropertyAddress')?.valueChanges.subscribe((res: any) => {
      if (res) {
        this.propertyInfoForm.patchValue({
          mailingAddress: this.propertyInfoForm?.value?.propertyAddress
        })
      } else {
        this.propertyInfoForm.patchValue({
          mailingAddress: {
            unitNumber: null,
            address: null,
            state: null,
            city: null,
            zip: null,
          }
        })
      }
    });
    this.coverageInfoForm.get('optionalPlanItems')?.valueChanges.subscribe((res:any)=>{
      let data = res.map((item:any)=>{
       return this.coverItemList.find((res:any)=>{
          return res?.planCoverItemId === item;
        })
      })
      this.selectedCoverItemList = data.map((item:any)=> item?.title)
    })
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.prpoertyLocation)
        this.mapsService.autoFillLocation(
          this.prpoertyLocation,
          'propertyAddress'
        );

      if (this.billingLocation)
        this.mapsService.autoFillLocation(
          this.billingLocation,
          'billingLocation'
        );
      
      this.mapsService.autoFillLocation(
        this.mailingAddress,
        'mailingAddress'
      );

    }, 200);
    this.subs.push(this.mapsService.getaddressEvent.pipe(takeUntil(this.destroyed$)).subscribe((res: any) => {
      if (res && typeof (res) === 'object' && res.root === 'propertyAddress') {
        this.propertyInfoForm.patchValue({
          propertyAddress: {
            streetAddress: res?.address,
            state: res?.state,
            city: res?.city,
            zip: res?.zipcode,
          }
        })
      }
    }));
    this.subs.push(this.mapsService.getaddressEvent.pipe(takeUntil(this.destroyed$)).subscribe((res: any) => {
      if (res && typeof (res) === 'object' && res.root === 'billingLocation') {
        this.propertyInfoForm.patchValue({
          billingAddress: {
            streetAddress: res?.address,
            state: res?.state,
            city: res?.city,
            zip: res?.zipcode,
          }
        })
      }
    }));
    
    this.subs.push(this.mapsService.getaddressEvent.pipe(takeUntil(this.destroyed$)).subscribe((res: any) => {
      if (res && typeof (res) === 'object' && res.root === 'mailingAddress') {
        this.propertyInfoForm.patchValue({
          mailingAddress: {
            streetAddress: res?.address,
            state: res?.state,
            city: res?.city,
            zip: res?.zipcode,
          }
        })
      }
    }));

  }
  formInit() {
    //Customer Information form
    this.customerInformationForm = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.minLength(2)]),
      lastName: new FormControl('', [Validators.required, Validators.minLength(2)]),
      // mobileNumberCountryCode: new FormControl('', [Validators.pattern(/^(\+?\d{1,3}|\d{1,4})$/)]),
      mobileNumber: new FormControl('', [Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),]),
      // homeNumberCountryCode: new FormControl('', [Validators.pattern(/^(\+?\d{1,3}|\d{1,4})$/)]),
      homeNumber: new FormControl(null, [Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/)]),
      // secondaryMobileNumberCountryCode: new FormControl('',[Validators.pattern(/^(\+?\d{1,3}|\d{1,4})$/)]),
      secondaryMobileNumber: new FormControl(null, [Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/)]),
      emailAddress: new FormControl('', [Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)]),
      secondaryEmailAddress: new FormControl(null, [Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)])
    });
    this.sourceForm = new FormGroup({
      leadNumber: new FormControl(null),
      leadSource: new FormControl(null),
      leadCost: new FormControl(null),
      externalId: new FormControl(null),
      subId: new FormControl(null),
      clickId: new FormControl(null),
      traffic: new FormControl(null),
      position: new FormControl(null),
      refKeyword: new FormControl(null),
      referralWebsite: new FormControl(null, ),
      internalUrl: new FormControl(null, ),
      gclid: new FormControl(null),
    });
    this.securityForm = new FormGroup({
      deviceType: new FormControl(null,),
      deviceId: new FormControl(null,),
      mobile: new FormControl(null,),
      phoneStatus: new FormControl(null,),
      emailStatus: new FormControl(null,),
      verifiedName: new FormControl(null,),
      nationalDnc: new FormControl(null,),
      stateDnc: new FormControl(null,),
      dma: new FormControl(null,),
      dncLitigator: new FormControl(null,),
      ipAddress: new FormControl(null),
      formSubmission: new FormControl(null),
      emailCount: new FormControl(null),
      phoneCount: new FormControl(null),
      ipCount: new FormControl(null),
      network: new FormGroup({
        autonomous_system_number: new FormControl(null),
        autonomous_system_organization: new FormControl(null),
        network: new FormControl(null),
      }),
      security: new FormGroup({
        proxy: new FormControl(null),
        relay: new FormControl(null),
        tor: new FormControl(null),
        vpn: new FormControl(null),
      }),
      location: new FormGroup({
        city: new FormControl(null),
        continent: new FormControl(null),
        continent_code: new FormControl(null),
        country: new FormControl(null),
        country_code: new FormControl(null),
        is_in_european_union: new FormControl(null),
        latitude: new FormControl(null),
        locale_code: new FormControl(null),
        longitude: new FormControl(null),
        metro_code: new FormControl(null),
        region: new FormControl(null),
        region_code: new FormControl(null),
        time_zone: new FormControl(null),
      }),
    });
    this.propertyInfoForm = new FormGroup({
      propertyTypeId: new FormControl(null,),
      propertySizeId: new FormControl(null,),
      propertyValue: new FormControl(null, [Validators.min(0)]),
      propertyAddress: new FormGroup({
        unitNumber: new FormControl(null),
        streetAddress: new FormControl('', [Validators.required]),
        state: new FormControl('', [Validators.required]),
        city: new FormControl('', [Validators.required]),
        zip: new FormControl('', [Validators.required]),
      }),
      billingAddress: new FormGroup({
        unitNumber: new FormControl(null),
        streetAddress: new FormControl(null),
        state: new FormControl(null),
        city: new FormControl(null),
        zip: new FormControl(null),
        sameAsPropertyAddress: new FormControl(''),
      }),
      mailingAddress: new FormGroup({
        unitNumber: new FormControl(null),
        streetAddress: new FormControl(null),
        state: new FormControl(null),
        city: new FormControl(null),
        zip: new FormControl(null),
        sameAsPropertyAddress: new FormControl(''),
      }),
    });
    this.coverageInfoForm = new FormGroup({
      planId: new FormControl(null),
      optionalPlanItems: new FormControl([],),
      coverageTerm: new FormControl(null),
      freeMonth: new FormControl(null),
      coPaymentFee: new FormControl(null),
      planCost: new FormControl(null),
      surcharge: new FormControl(null),
      totalCost: new FormControl(null),
      discount: new FormControl(null),
      monthlyPayment: new FormControl(null),
      additionalPrice: new FormControl(null),
      downPaymentAmount: new FormControl(null),
      agreementNumber: new FormControl(null),
      waitingPeriod: new FormControl(null),
      agreementEffectiveDate: new FormControl(null),
      agreementExpireDate: new FormControl(null),
      agreementPurchaseDate: new FormControl(null),
      // remainingAmount: new FormControl(null)
    });
    this.paymentInfoForm = new FormGroup({
      transactionId: new FormControl(null),
      amount: new FormControl(null),
      cardType: new FormControl(null),
      cardLastFourDigit: new FormControl(null),
      createdAt: new FormControl(null),
    })
  }

  getLeadDetails() {
    this.loader = true;
    this.apiservice.get('admin/lead/get-lead/' + this.id).subscribe((res: any) => {
      if (res.body) {
        this.loader = false;
        this.leadDetails = res?.body?.lead;
        this.noteLists = res?.body?.lead?.notes;   
        this.customerInformationForm.patchValue(res?.body?.lead?.customerInformation);
        this.sourceForm.patchValue(res?.body?.lead?.source);
        this.securityForm.patchValue(res?.body?.lead?.security);
        this.securityForm.patchValue({
          network: res?.body?.lead?.security?.security?.network,
          security: res?.body?.lead?.security?.security?.security
        })
        this.propertyInfoForm.patchValue(res?.body?.lead?.propertyInformation);
        this.propertyInfoForm.patchValue({
          propertyTypeId: res?.body?.lead?.propertyInformation?.propertyType?.id,
          propertySizeId: res?.body?.lead?.propertyInformation?.propertySize?.id,
          propertyAddress: {
            address: res?.body?.lead?.propertyInformation?.propertyAddress?.streetAddress
          }
        });
        this.propertyInfoForm.patchValue({
          billingAddress: {
            streetAddress: res?.body?.lead?.agreementInformation.billingAddress.address,
            state: res?.body?.lead?.agreementInformation.billingAddress.state,
            city: res?.body?.lead?.agreementInformation.billingAddress.city,
            zip: res?.body?.lead?.agreementInformation.billingAddress.zip
          }
        })
        this.selectCoverItems = res?.body?.lead?.coverageInformation?.optionalItems;
        this.coverageInfoForm.patchValue(res?.body?.lead?.agreementInformation);
        
        this.coverageInfoForm.patchValue({
          planId: this.leadDetails?.agreementInformation?.orderPlanDetail?.orderMainPlanDetails?.plan_optional_item_category?.planOptionalItemCategoryId,
          optionalPlanItems: this.leadDetails?.agreementInformation?.orderAdditionalItems.map((item: any) => item?.orderCoveredItemDetail?.planCoverItemId),
          coverageTerm : this.leadDetails?.agreementInformation?.pricingOption,
          freeMonth: this.leadDetails?.agreementInformation?.freeMonth,
          coPaymentFee: this.leadDetails?.agreementInformation?.copayFee,
          planCost: this.leadDetails?.agreementInformation?.agreementPrice,
          surcharge: this.leadDetails?.agreementInformation?.surchargeAmount,
          totalCost: this.leadDetails?.agreementInformation?.totalCost,
          discount: this.leadDetails?.agreementInformation?.discountedPrice,
          monthlyPayment:  this.leadDetails?.agreementInformation?.monthlyPayment
        });
        this.paymentInfoForm.patchValue(this.leadDetails?.agreementInformation?.orderPaymentDetail);
        if(this.leadDetails?.agreementInformation?.orderPaymentDetail?.createdAt){
          this.paymentInfoForm.patchValue({
            createdAt: moment(this.leadDetails?.agreementInformation?.orderPaymentDetail?.createdAt).format('YYYY-MM-DD')
          });
        }
        if(JSON.stringify(res?.body?.lead?.propertyInformation?.propertyAddress) === JSON.stringify(res?.body?.lead?.propertyInformation?.billingAddress) ){
          this.propertyInfoForm.patchValue({
            billingAddress : {
              sameAsPropertyAddress : true
            }
          })
        };
        if(JSON.stringify(res?.body?.lead?.propertyInformation?.propertyAddress) === JSON.stringify(res?.body?.lead?.propertyInformation?.coverageAddress
          )){
          this.propertyInfoForm.patchValue({
            coverageAddress: {
              sameAsPropertyAddress : true
            }
          })
        };
        if(JSON.stringify(res?.body?.lead?.propertyInformation?.propertyAddress) === JSON.stringify(res?.body?.lead?.propertyInformation?.mailingAddress
          )){
          this.propertyInfoForm.patchValue({
            mailingAddress: {
              sameAsPropertyAddress : true
            }
          })
        };
        this.cdr.detectChanges();
        // if(this.leadDetails.source?.leadSource.startsWith('000')){
          this.checkFieldError();
          // } 
      }
    })
  };
  getBlackListedIpaddress(){
    this.apiservice.get('admin/security/blacklisted-ip/get-all-blacklisted-ips?page=1&size=9999').subscribe((res:any)=>{
      this.blacklistedIpAdddressList = res?.body?.blacklisted_ips?.data;
    })
  }
  getPropertyType() {
    this.apiservice
      .get('admin/plan/property-type/get-property-types?page=1&size=9999')
      .subscribe(
        (res: any) => {
          if (res.body) {
           
            this.propertyTypeList = res.body?.planPropertyTypes?.data;
          }
        },
        (err) => { }
      );
  };
  getPropertySizeList() {
    this.apiservice
      .get('admin/plan/property-size/get-property-sizes?page=1&size=9999')
      .subscribe(
        (res: any) => {
          if (res.body) {
           
            this.propertySizeList = res.body?.planPropertySizes?.data;
          }
        },
        (err) => { }
      );
  }
  getPlanList() {
    return new Promise((resolve, reject) => {
      this.apiservice.get('admin/plan/optional-item-category/get-all-optional-item-categories?type=main&page=1&size=100').subscribe((res: any) => {
        if (res?.body) {
          
          this.planList = res.body?.planOptionalItemCategories?.data;
          if (this.planList) {
            let planId = this.coverageInfoForm.controls['planId'].value;
            if (planId) {
              let tempData = this.planList.find((elm: any) => {
                return elm?.planOptionalItemCategoryId === planId;
              });
              this.planListCoverItems = tempData?.coveredItems.map((item: any) => {
                return { ...item, isChecked: false };
              });

            }

          }
          resolve(true);
        }
      })
    })

  };
  planChanges() {
    this.selectCoverItems = [];
    this.coverageInfoForm.patchValue({
      optionalPlanItems: this.selectCoverItems
    })
    this.planListCoverItems = this.planListCoverItems.map((item: any) => {
      return { ...item, isChecked: false }
    })
  }
  optionalCoverItemChange(event: any, id: any) {
    const { name, checked, value } = event.target;
    if (checked) {
      this.selectCoverItems.push(value);
    } else {
      let removeIndex = this.selectCoverItems.findIndex((itm: any) => itm === value);
      if (removeIndex !== -1)
        this.selectCoverItems.splice(removeIndex, 1);
    }
    this.coverageInfoForm.patchValue({
      optionalPlanItems: this.selectCoverItems
    })

  }
  getCoverItemList() {
    this.apiservice.get('admin/plan/covered-item/get-covered-items?page=1&size=999').subscribe((res: any) => {
      if (res?.body) {
       
        this.coverItemList = res?.body?.planCoverItems?.data;
      }
    })
  }
  changeParams(data: string) {
    this.router.navigateByUrl('/lead/lead-details/' + this.id + '?type=' + data);
  };
  openDialog(data: any) {
    const dataWithLeadId = data;
    dataWithLeadId.leadId = this.id;
    this.dialog.open(UpdateNoteModalComponent, {
      data: dataWithLeadId,
      width: '600px',
    }).afterClosed().subscribe((res: any) => {
      if (res) {
        this.getLeadDetails();
      }

    })
  }
  openCreateNotesModal() {
    this.dialog.open(CreateNoteModalComponent, {
      data: this.id,
      width: '600px',
    }).afterClosed().subscribe((res: any) => {
      if (res) {
        this.getLeadDetails();
      }
    })
  }
  deleteNote(noteID: any) {
    this.apiservice.delete('admin/lead/delete-lead-note/' + noteID).subscribe((res: any) => {
      if (res?.body) {
        this.getLeadDetails();
        this.apiservice.alert('Lead Note Deleted Successfully', 'success');
      }
    }, err => {
      this.apiservice.alert('Please try again!', 'error');
    })
  }
  submitCustomerInformation() {
    if (this.customerInformationForm.valid) {
      this.apiservice.patch('admin/lead/update-lead-customer-information/' + this.id, this.customerInformationForm.value).subscribe((res: any) => {
        this.apiservice.alert(res?.body?.message, 'success')
        this.getLeadDetails();
      }, err => {
        this.apiservice.alert(err.message, 'error');
      })
    } else {
      this.customerInformationForm.markAllAsTouched();
    }
  };
  submitSourceForm() {
    let Value = {
      leadNumber: this.sourceForm.value?.leadNumber,
      leadCost: this.sourceForm.value?.leadCost
    }
    if (this.sourceForm.valid) {
      this.apiservice.patch('admin/lead/update-lead-source-information/' + this.id, Value).subscribe((res: any) => {
        if (res.body) {
          this.getLeadDetails();
          this.apiservice.alert(res.body?.message, 'success');
        }
      }, err => {
        this.apiservice.alert(err?.message, 'error');
      })
    } else {
      this.sourceForm.markAllAsTouched();
    }
  }
  submitSecurityForm() {
    if (this.securityForm.valid) {
      this.apiservice.patch('admin/lead/update-lead-security-information/' + this.id, this.securityForm.value).subscribe((res: any) => {
        if (res.body) {
          this.getLeadDetails();
          this.apiservice.alert(res.body?.message, 'success');
        }
      }, err => {
        this.apiservice.alert(err?.message, 'error');
      })
    } else {
      this.securityForm.markAllAsTouched();
    }
  }
  submitPropertyInfoForm() {
    if (this.propertyInfoForm.valid) {
      let data = this.propertyInfoForm.value;
      delete data.billingAddress?.sameAsPropertyAddress;
      delete data.mailingAddress?.sameAsPropertyAddress;
      delete data.coverageAddress?.sameAsPropertyAddress;
      this.apiservice.patch('admin/lead/update-lead-property-information/' + this.id, this.propertyInfoForm.value).subscribe((res: any) => {
        if (res.body) {
          this.getLeadDetails();
          this.apiservice.alert(res.body?.message, 'success');
        }
      }, err => {
        this.apiservice.alert(err?.message, 'error');
      })
    } else {
      this.propertyInfoForm.markAllAsTouched();
    }
  }
  submitCoverageInfoForm() {
    if (this.coverageInfoForm.valid) {
      let data = this.coverageInfoForm.value;
      if(!data.existingCoverage){
        data.existingCompanyName = null;
        data.existingPolicyExpirationDate = null;
      }
      this.apiservice.patch('admin/lead/update-lead-coverage-information/' + this.id, data).subscribe((res: any) => {
        if (res.body) {
          this.getLeadDetails();
          this.apiservice.alert(res.body?.message, 'success');
        }
      }, err => {
        this.apiservice.alert(err?.message, 'error');
      })
     
    } else {
      this.coverageInfoForm.markAllAsTouched();
    }
  };
  navigateLeadDetailsPage(leadId:any){
    this.router.navigateByUrl('/lead/lead-details/'+ leadId + '?type=customerInformation');
  }

  isDateBetween24Hours(timeStamp: any): boolean {
    let status = true;
    if(timeStamp) {
      const nextDay = moment(timeStamp).add(24, 'hours');
      status = moment.utc().isBefore(moment.utc(nextDay), 'milliseconds');
    }
    return status;
  }
  proxyError!:boolean;
  realyError!:boolean;
  torError!:boolean;
  vpnError!:boolean;
  ipAddress:any;
  phoneError!:boolean;
  emailError!:boolean;

  checkFieldError(){
    //check proxy
    if(this.leadDetails?.security?.security?.security?.proxy){
      this.proxyError = true
    }
    if(this.leadDetails?.security?.security?.security?.relay){
      this.realyError = true
    }
    if(this.leadDetails?.security?.security?.security?.tor){
      this.torError = true
    }
    if(this.leadDetails?.security?.security?.security?.vpn){
      this.vpnError = true
    }
    //check ip address.
    this.ipAddress = this.blacklistedIpAdddressList.find((ip:any)=>{
      return ip?.ipAddress === this.leadDetails?.security?.ipAddress;
    });
    //check phone
    if(this.leadDetails.security?.phoneStatus && this.leadDetails.security?.phoneStatus.startsWith('N-')){
      this.phoneError = true;
      this.customerInformationForm.controls['mobileNumber'].setErrors({notValid: true});
    }
    //check email 
    if(this.leadDetails.security?.emailStatus){
      if(this.leadDetails.security?.emailStatus !== 'valid'){
        this.emailError = true;
        this.customerInformationForm.controls['emailAddress'].setErrors({notValid: true});
      }
    }
   
  };
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;

  getRelatedPolicieList(){
    this.apiservice.get(`admin/lead/get-related-policies?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&leadId=${this.id}`).subscribe((res:any)=>{
      if(res?.body){
        this.dataSource = res?.body?.relatedPolicies?.data;
        this.totalCount = res?.body?.relatedPolicies?.total;
      }
    })
  }
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getRelatedPolicieList();
  }
  leadPageSize = 30;
  leadTotalCount: number = 0;
  leadPageIndex: number = 0;
  getRelatedLeadList(){
    this.apiservice.get(`admin/lead/get-related-leads?page=${Number(this.leadPageIndex) + 1}&size=${this.leadPageSize}&leadId=${this.id}`).subscribe((res:any)=>{
      if(res?.body){
        this.relatedLeadDataSource = res?.body?.relatedLeads?.data;
        this.leadTotalCount = res?.body?.relatedLeads?.total;
      }
    })
  }
  leadPageSizeChange(event: any) {    
    this.leadPageSize = event.pageSize;
    this.leadPageIndex = event.pageIndex;
    this.getRelatedLeadList();
  }

}
